import React, {Component} from 'react'

import Content from '../Content'
import Item from '../Item'
import Link from '../Link'
import List from '../Lists'

class LotInfo extends Component {

  render () {

    const {
      entry
    } = this.props

    let type = entry.locationCategory

    if ( type == "park") {
      return (
        <div className="Template-section Template-section--narrow">
                <div className="Template-heading">
                <Content modifier={'alt'}>
                  <h1>Lot Info</h1>
                </Content>
                </div>
                <div className="Template-content">
                  <Content html={entry.lotInfo}/>
                </div>
              </div>
      )
    } else {
      return null;
    }
  }
}

export default LotInfo



// WEBPACK FOOTER //
// ./src/js/components/LotInfo/LotInfo.jsx